export enum ArchiveStatus {
  UNLOCK = 'UNLOCK',
  LOCKING = 'LOCKING',
  LOCK = 'LOCK',
}

export const ArchiveStatusMap = {
  [ArchiveStatus.UNLOCK]: '未锁定',
  [ArchiveStatus.LOCKING]: '锁定中',
  [ArchiveStatus.LOCK]: '已锁定',
};

export const ArchiveStatusOptions = [
  {
    label: ArchiveStatusMap[ArchiveStatus.UNLOCK],
    value: ArchiveStatus.UNLOCK,
  },
  {
    label: ArchiveStatusMap[ArchiveStatus.LOCKING],
    value: ArchiveStatus.LOCKING,
  },
  { label: ArchiveStatusMap[ArchiveStatus.LOCK], value: ArchiveStatus.LOCK },
];
